export default __webpack_public_path__ + "static/media/arena-of-valor.a690d416.png";